<template>
  <div class="item-content-raw">
    <!--<h3>海报模板</h3>-->

    <!--<template>
      <div
        v-for="(item) in rawData"
        :key="item.id"
      >
        <div
          v-if="item.itemType === 3"
          class="item1"
          @click="confirmMessage(4, item.attachments)"
        >
          <a style="display: none;"
             :ref="'fileLink' + getAttachmentById(4, item.attachments)"
             :href="'/' + getAttachmentByType(4, item.attachments)"
          >代替链接</a>
          &lt;!&ndash; 图标图片 &ndash;&gt;
          &lt;!&ndash;<img
            v-if="getAttachmentByType(2, item.attachments)"
            class="icon-item"
            :src="'/' + getAttachmentByType(2, item.attachments)"
            alt=""
          >&ndash;&gt;
          &lt;!&ndash; 文字 &ndash;&gt;
          <p v-html="item.title"></p>
        </div>
        <div
          v-else
          class="item1"
          @click="onClick(item)"
        >
          &lt;!&ndash; 图标图片 &ndash;&gt;
          &lt;!&ndash;<img
            v-if="getAttachmentByType(2, item.attachments)"
            class="icon-item"
            :src="'/' + getAttachmentByType(2, item.attachments)"
            alt=""
          >&ndash;&gt;
          &lt;!&ndash; 文字 &ndash;&gt;
          <p v-html="item.title"></p>
        </div>
      </div>
    </template>-->
    <div class="poster-container">
      <div class="poster-box"
        v-for="item in rawData" :key="item.id"
        @click="onClick(item)">
        <!-- 图片缩略图 -->
        <!--
        * 2 -> 是图标 (还是缩略图?)
        * 1 -> 是封面
        -->
        <div class="poster-template">
          <img class="cover-style"
            :src="'/' + getAttachmentByType(1, item.attachments)" alt="">
          <!-- 图片名 -->
          <div class="img-name" :title="item.title" v-html="item.title"></div>
        </div>
      </div>
    </div>
    <!-- 底部文字 -->
    <!--<p class="fxtip" v-if="bottomInfo[0]">
      {{ bottomInfo[0] }}
    </p>-->
  </div>
</template>
<script>
export default {
  name: 'PagePlaybillTemplate',
  props: {
    // 数据源头
    rawData: {
      type: Array,
      default: () => []
    },
    // 底部信息
    bottomInfo: {
      type: Array,
      default: () => []
    },
    // 跳转函数
    onClick: {
      type: Function,
      default: function () {}
    }
  },
  data () {
    return {}
  },
  methods: {
    getAttachmentById (t, attachmentList) {
      for (let e of attachmentList) {
        if (e.attachmentType === t) {
          return e.id
        }
      }
    },
    confirmMessage (attachmentType, attachmentList) {
      let attachmentName
      let attachmentId
      let attachmentPath
      for (let e of attachmentList) {
        if (e.attachmentType === attachmentType) {
          attachmentName = e.name
          attachmentId = e.id
          attachmentPath = e.path
          break
        }
      }
      if (attachmentName) {
        let fileFormat = attachmentName.substr(attachmentName.lastIndexOf('.')).toLowerCase()
        if (fileFormat === '.pdf' || fileFormat === '.doc' || fileFormat === '.docx' || fileFormat === '.ppt' || fileFormat === '.pptx') {
          this.$nextTick(() => {
            this.$router.push({
              name: 'FileConvertedImage',
              query: {
                attachmentId: attachmentId,
                attachmentPath: attachmentPath,
                title: attachmentName
              }
            })
          })
        } else {
          this.$refs['fileLink' + attachmentId][0].click()
          return false
        }
      }
    },
    // 获取指定附件类型的 path
    getAttachmentByType (t, attachments) {
      // t：1封面
      for (let e of attachments) {
        if (e.attachmentType === t) {
          return e.path
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../assets/scss/theme/_default_variables";
  * {
    box-sizing: border-box;
  }

  /* 宣传海报 */
  .poster-container {
    display: flex;
    flex-wrap: wrap;

    .poster-box {
      display: flex;
      width: 33.33%;

      .poster-template {
        margin: $margin-container/2 auto;
        margin-bottom: 0;
        width: 2.1rem;
      }

      img {
        width: 2.1rem;
        height: 2rem;
      }

      .img-name {
        margin-top: 5px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        text-align: center;
      }
    }
  }

  .cover-style {
    width: 100%;
    height: 70px;
    max-width: 100%;
    max-height: 100%;
    object-fit: cover;
    object-position: left top;
    border-radius: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/components/ui/PagePlaybillTemplate.vue